import React from 'react'
import { useAtom } from 'jotai'
import Classnames from 'classnames'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

// block renderer
import BlockRenderer from '@/components/optypes/frontend/BlockRenderer'

// block builder tools
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'
import AddBlockBuilder from '@/components/optypes/frontend/AddBlockBuilder'

// blocks
import Block1 from '@/components/optypes/frontend/BookReview/Block1'
import Block2 from '@/components/optypes/frontend/BookReview/Block2'

const Components = {
  block_1: Block1,
  block_repeatable: Block2,
}

const BookReviewRender = () => {
  const [builder] = useAtom(isBuilder)

  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div className="p-16">
      <div
        className="text-3xl font-bold mb-16 p-6"
        style={{
          backgroundColor: returnValue('main_background', opDesign, pageDesign),
        }}
      >
        Book review component renderer...
      </div>

      <h2 className="font-bold text-2xl mb-4">
        <StaticContentWrapper contentKey="main_headline">
          {returnValue('main_headline', opStatic, pageStatic)}
        </StaticContentWrapper>
      </h2>
      <h2 className="font-bold text-2xl mb-4">
        <StaticContentWrapper contentKey="second_headline">
          {returnValue('second_headline', opStatic, pageStatic)}
        </StaticContentWrapper>
      </h2>

      <h2 className="font-bold text-2xl mb-4">
        <StaticContentWrapper contentKey="third_headline">
          {returnValue('third_headline', opStatic, pageStatic)}
        </StaticContentWrapper>
      </h2>

      <StaticContentWrapper contentKey="second_headline">
        <h2
          className={Classnames('font-bold text-6xl mb-4', {
            'text-red-600': returnValue('warning_text', opDesign, pageDesign),
          })}
        >
          {returnValue('second_headline', opStatic, pageStatic)}
        </h2>
      </StaticContentWrapper>

      <h2 className="font-bold text-2xl mb-4 bg-gray-200 p-2 rounded">
        <p className="">SELECT OPTION TEST</p>
        {returnValue('select_dev', opStatic, pageStatic)}
      </h2>

      <h2
        className="font-bold text-2xl mb-4 bg-gray-200 p-2 rounded"
        style={{ opacity: returnValue('header_opacity', opDesign, pageDesign) }}
      >
        <p className="">OPAICTY SLIDER TEST</p>
        {returnValue('header_opacity', opDesign, pageDesign)}
        <p className="">IMG URL::</p>
        {returnValue('background_img', opDesign, pageDesign)}
      </h2>

      {returnValue('optional', opStatic, pageStatic) == 'show' && (
        <div className="mt-3 bg-gray-200">Optional renderer thing..</div>
      )}

      {/* example of a missing key error */}
      {/* {returnValue('something', opStatic, pageStatic)} */}

      <h2 className="mt-16">Block Example</h2>

      <div className="mt-6 p-5 shadow rounded border-2 border-gray-300">
        {pageBlocks.map((block, index) => (
          <BlockRenderer
            key={index}
            index={index}
            Components={Components}
            block={block}
          />
        ))}

        {/* add block button builder */}
        {builder && (
          <AddBlockBuilder
            bgColor="bg-blue-600 hover:bg-blue-500"
            btnText="Add Menu Block"
          />
        )}
      </div>
    </div>
  )
}

export default BookReviewRender
